
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/antara/api/assets",
      function () {
        return require("private-next-pages/docs/antara/api/assets/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/antara/api/assets"])
      });
    }
  